import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';

/**
 * Freshness of the leavers list: `{ checked, last_synced_at, stale }` from
 * GET /api/users/leavers-summary. Fetched only when the users list carries
 * leaver data. Any failure is 'error' (unknown), never "checked, none left".
 * @returns {{ status: 'idle'|'loading'|'ready'|'error', summary: object|null }}
 */
export default function useLeaversSummary(enabled) {
  const [state, setState] = useState({ status: enabled ? 'loading' : 'idle', summary: null });

  useEffect(() => {
    if (!enabled) {
      setState({ status: 'idle', summary: null });
      return undefined;
    }
    let active = true;
    setState({ status: 'loading', summary: null });
    axios.get(`${API_BASE_URL}/api/users/leavers-summary`, { withCredentials: true })
      .then((r) => {
        if (!active) return;
        const ok = r && r.data && typeof r.data.checked === 'boolean';
        setState(ok ? { status: 'ready', summary: r.data } : { status: 'error', summary: null });
      })
      .catch(() => { if (active) setState({ status: 'error', summary: null }); });
    return () => { active = false; };
  }, [enabled]);

  return state;
}
